<template>
  <div class="mobil-wrapper">
    <div class="row align-items-stretch mobil-row">
      <div class="col-lg-1 d-none d-lg-block"></div>
      <div class="col-lg-5 col-md-7 col-sm-12 col-xs-12 mobil-col-form px-5">
        <div class="prediccionesMobil-container-texto mb-4">
          <!-- <h1 class="font-white font-bold prediccionesMobil-titulo italic">
            Ahora, podrás sentir la misma emoción que un piloto de la F1
          </h1>
          <p class="font-white font-regular prediccionesMobil-texto">
            A partir de ahora, en cuanto abras las predicciones de cada GP, arrancará un cronómetro de 2 minutos. Ese es
            el tiempo que tendrás para leer, decidir y actuar. Sin pausas ni distracciones. Solo tú y la adrenalina del
            momento.
            ¿Cómo funciona?

            1. Entra a tu cuenta y abre las predicciones de la carrera.
            En ese momento arranca el cronómetro. ¡Tienes bandera verde para comenzar!

            2. Responde todas las preguntas en menos de 2 minutos.
            Lee, decide y confirma. Llevas toda la temporada siguiendo la acción, ¡confía en tu instinto y velocidad!

            3. ¿Se cerró la sesión antes de terminar?
            No te preocupes piloto, puedes volver a iniciar sesión para terminar de responder las preguntas que te hayan
            faltado. Los campeones no le temen a una segunda vuelta.

            La victoria no espera a nadie. ¿Estás listo para demostrar que tienes la velocidad de un campeón?

            ¡Nos vemos en la pista!
          </p> -->
        </div>
        <div v-if="showPredictionTimer" class="prediction-countdown-banner">
          Tiempo para enviar: {{ predictionTimerLabel }}
        </div>
        <div class="contenedor-Mobilpredicciones text-center py-5">
          <!-- <h1 class="font-white f40 mt-5">{{name_race}}</h1>
          <p class="font-white font-regular">{{circuito}}</p>
          <p class="font-white font-regular">{{ciudad}}</p> -->
          <div class="container-botones-predicciones">
            <div class="">
              <button @click="alertaCambioPaginaPilotos" class="piloto2 font-white font-regular font-regular italic">
                Max
              </button>
            </div>
            <div class="boton-secundario">
              <button @click="alertaCambioPaginaPilotos" class="piloto2 font-white font-regular font-regular italic">
                Isack
              </button>
            </div>
            <div class="boton-secundario">
              <a href="/predicciones-pilotos-isack" class="piloto font-white page-predicciones italic">Mobil</a>
            </div>
          </div>
          <div class="predicciones">
            <p class="font-white f40 mt-5" v-if="!showQuestions">
              Predicciones no disponibles, se abren el lunes antes de la carrera.
            </p>
            <form class="" action="" @submit.prevent="submitFormQuestionsMobil" v-if="showQuestions && !isFormVisible">
              <!-- Pregunta 1 -->
              <h3 class="pregunta font-white font-regular mt-3">
                {{ form[0].pregunta1 }}
              </h3>
              <div class="d-flex justify-between mt-3">
                <select class="input-predicciones" v-model="form[0].respuesta1">
                  <option disabled value="">Respuesta</option>
                  <option v-for="option in form[0].options" :key="option.id" :value="option.id">{{ option.text }}
                  </option>
                </select>
                <p class="font-white font-regular score mt-3">50 Puntos</p>
              </div>
              <!-- Pregunta abierta (campo de texto) comentada para reutilización futura -->
              <!-- <div class="d-flex justify-between mt-3">
                <input
                  type="text"
                  v-model="form[0].respuesta1"
                  placeholder="Escribe tu respuesta aquí"
                  class="input-predicciones"
                  maxlength="500"
                />
                <p class="font-white font-regular score mt-3">50 Puntos</p>
              </div> -->
              <!-- Fin de pregunta 1 -->
              <!-- Pregunta 2 -->
              <h3 class="pregunta font-white font-regular mt-3">
                {{ form[1].pregunta2 }}
              </h3>
              <div class="d-flex justify-between mt-3">
                <select class="input-predicciones" v-model="form[1].respuesta2">
                  <option disabled value="">Respuesta</option>
                  <option v-for="option in form[1].options" :key="option.id" :value="option.id">{{ option.text }}
                  </option>
                </select>
                <p class="font-white font-regular score mt-3">50 Puntos</p>
              </div>
              <!-- <div v-if="form[1].respuesta2 === 'D'" class="mt-3">
                <input type="text" v-model="form[1].otraRespuesta" placeholder="Especifica tu medio de transporte" class="input-predicciones" />
              </div> -->
              <!-- Fin de pregunta 2 -->
              <div class="d-flex justify-center my-5">
                <button class="btn btn-lg"
                  :class="{ 'btn-launch-predicciones': isFormComplete, 'btn-launch-predicciones-disabled': !isFormComplete }"
                  :disabled="!isFormComplete">
                  Enviar respuestas
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-lg-5 col-md-5 d-md-flex mobil-col-image align-items-end">
        <img class="prediccionesMobil-imagen" :src="require('../../../../../src/assets/2026/predicciones_mobil.png')"
          alt="Mobil" />
      </div>
      <div class="col-lg-1 d-none d-lg-block"></div>
    </div>
  </div>
</template>
<script src="./mobil.js" />
<style src="../pilotos/pilotos.scss" lang="scss" />
<style src="./mobil.scss" lang="scss" />
<style src="../../../../App.scss" lang="scss" />
<style lang="scss">
.prediction-countdown-banner {
  width: 100%;
  background: #fe0000;
  color: #fff;
  border-radius: 14px;
  padding: 10px 14px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 12px;
}
</style>
<!-- <style src="../predicciones/predicciones.scss" lang="scss" />  -->
<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "mobil",
  metaInfo: {
    title: "Predicciones | Mobil Predictor",
    meta: [
      {
        name: "title",
        content: "Predicciones | Mobil Predictor",
      },
      {
        name: "description",
        content:
          "¡Pronostica resultados de los pilotos de Oracle Red Bull Racing! Adivina en qué lugar quedarán Max Verstappen y Isack. ¡Vence a los demás!",
      },
    ],
  },
  data() {
    return {
      questions: [],
      form: [
        {
          pregunta1: "Mobil™ no solo impulsa motores, también impulsa talento. ¿Qué pilotas forman parte del Porsche Mobil 1 Female Driver Program?",
          respuesta1: "",
          options: [
            { id: "A", text: "A) Jamie Chadwick y Loni Unser" },
            { id: "B", text: "B) Therese Lahlouh y Anna Cecchi" },
            { id: "C", text: "C) Erika Hoffmann y Ashley Freiberg" },
            { id: "D", text: "D) Madeline Stewart y Sabré Cook" },
            { id: "E", text: "E) Todas las anteriores" },
          ],
          otraRespuesta: "",
        },
        {
          pregunta2: "Los aceites sintéticos, como Mobil 1™, ofrecen una protección superior a los minerales. ¿Cuál es una de las razones científicas principales?",
          respuesta2: "",
          options: [
            { id: "A", text: "A) Sus moléculas son de tamaño uniforme, reduciendo la fricción interna" },
            { id: "B", text: "B) Son más densos y se adhieren mejor a las piezas" },
            { id: "C", text: "C) Contienen partículas metálicas que rellenan imperfecciones" },
            { id: "D", text: "D) Se evaporan más rápido, limpiando el motor" },
          ],
          otraRespuesta: "",
        },
      ],
      showQuestions: true,
      isFormVisible: false,
      name_race: "",
      circuito: "",
      ciudad: "",
      gp: "",
      predictionTimerLabel: "",
      showPredictionTimer: false,
      predictionTimerInterval: null,
    };
  },
  methods: {
    updatePredictionTimerLabel() {
      const deadline = Number(localStorage.getItem("prediction_timer_deadline"));

      if (!deadline) {
        this.showPredictionTimer = false;
        this.predictionTimerLabel = "";
        return;
      }

      const remaining = deadline - Date.now();
      if (remaining <= 0) {
        this.showPredictionTimer = false;
        this.predictionTimerLabel = "";
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      this.predictionTimerLabel = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
      this.showPredictionTimer = true;
    },
    startPredictionTimerLabel() {
      this.updatePredictionTimerLabel();

      if (this.predictionTimerInterval) {
        clearInterval(this.predictionTimerInterval);
      }

      this.predictionTimerInterval = setInterval(() => {
        this.updatePredictionTimerLabel();
      }, 1000);
    },
    getGP(){
      const gp = localStorage.getItem("gp");
      if (gp && gp !== "0") {
        this.showQuestions = true;
        this.gp = gp;
      }else{
        this.showQuestions = false;
        this.gp = gp;
      }
    },
    submitFormQuestionsMobil() {
      const gpRaw = this.gp || localStorage.getItem("gp");
      let normalizedGp = null;

      if (gpRaw && String(gpRaw) !== "0") {
        const rawText = String(gpRaw).trim();
        try {
          const parsedGp = JSON.parse(rawText);
          if (parsedGp && typeof parsedGp === "object") {
            normalizedGp =
              parsedGp.id ||
              parsedGp.gp ||
              parsedGp.race_id ||
              parsedGp.carrera_id ||
              null;
          } else if (parsedGp !== null && parsedGp !== undefined && parsedGp !== 0 && parsedGp !== "0") {
            normalizedGp = parsedGp;
          }
        } catch (e) {
          normalizedGp = rawText;
        }
      }

      if (!normalizedGp || String(normalizedGp) === "0") {
        console.error('[Predicciones] race id ausente, no se puede enviar payload', {
          gpRaw,
          localStorageGp: localStorage.getItem('gp')
        });
        Swal.fire({
          title: "¡Espera!",
          text: "No encontramos la carrera actual. Recarga la página e inténtalo de nuevo.",
          icon: "info",
          confirmButtonText: "Volver a intentar",
          background: "rgba(0, 20, 79, 0.8)",
          confirmButtonColor: "#ff0000",
          color: "#fff",
        });
        return;
      }

      // Recuperar el objeto existente de localStorage
      let predicciones = localStorage.getItem("predicciones");
      // Parsear el objeto JSON recuperado, o inicializar un objeto vacío si no existe
      predicciones = predicciones ? JSON.parse(predicciones) : {};
      const raceId = String(normalizedGp).replace(/^"|"$/g, "");
      const serializedGp = JSON.stringify(raceId);
      // Agregar el nuevo valor al objeto
      predicciones.Mobil = {
        gp: raceId,
        gp_json: serializedGp,
        race_id: raceId,
        raceId: raceId,
        ...this.form
      };
      // Compatibilidad: algunos endpoints leen gp/race_id en la raíz del payload
      predicciones.gp = raceId;
      predicciones.gp_json = serializedGp;
      predicciones.race_id = raceId;
      predicciones.raceId = raceId;
      // Guardar el objeto modificado de nuevo en localStorage
      localStorage.setItem("predicciones", JSON.stringify(predicciones));

      let prediccionesFinales = JSON.parse(localStorage.getItem("predicciones"));

  // DEBUG: log del payload antes de enviar
  console.log('[Predicciones] payload completo:', JSON.stringify(prediccionesFinales, null, 2));
  console.log('[Predicciones] claves presentes:', Object.keys(prediccionesFinales));
  console.log('[Predicciones] Max:', prediccionesFinales.Max);
  console.log('[Predicciones] Isack:', prediccionesFinales.Isack);
  console.log('[Predicciones] Mobil:', prediccionesFinales.Mobil);
  console.log('[Predicciones] gp crudo:', gpRaw);
  console.log('[Predicciones] gp raiz:', prediccionesFinales.gp, 'gp_json:', prediccionesFinales.gp_json, 'race_id:', prediccionesFinales.race_id, 'raceId:', prediccionesFinales.raceId);
  console.log('[Predicciones] auth_token:', localStorage.getItem('auth_token') ? 'presente' : 'AUSENTE');

  // Envía los datos a la API
  const token = localStorage.getItem('auth_token');
  axios
        .post(
          // "https://www.mobilpredictor.com.mx/datos/api/predicciones",
          // "http://127.0.0.1:8000/api/predicciones",
          "https://api.mobilpredictor2025.vmtec.com.mx/api/predicciones",
          prediccionesFinales,
          {
            params: {
              race_id: raceId,
              raceId: raceId,
              gp: raceId
            },
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
        .then((response) => {
          console.log('[Predicciones] respuesta del servidor:', response.status, response.data);

          localStorage.removeItem('prediction_timer_started');
          localStorage.removeItem('prediction_timer_deadline');

          // Borrar el objeto predicciones del LocalsStorage
          localStorage.removeItem("predicciones");

          document.cookie =
            "PrediccionesEnviadas=true; expires=" +
            new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toUTCString();

          setTimeout(() => {
            this.$router.push("/exito").catch(err => {
              if (err.name !== 'NavigationDuplicated') {
                throw err;
              }
            });
          }, 1000);
        })
        .catch((error) => {
          console.error('[Predicciones] error al enviar:', error?.response?.status, error?.response?.data);
          console.error('[Predicciones] detalle completo:', error);
          Swal.fire({
            title: "¡Espera!",
            text:
              "Envíanos tus respuestas completas para poder participar en el predictor y conseguir más puntos.",
            icon: "info",
            confirmButtonText: "Volver a intentar",
            background: "rgba(0, 20, 79, 0.8)",
            confirmButtonColor: "#ff0000",
            color: "#fff",
          });
        });
    },
    alertaCambioPaginaPilotos() {
      if (document.cookie.indexOf("respuestasMobil=mobil") === -1) {
        Swal.fire({
          title: "¡Espera!",
          text:
            "Recuerda que debes volver aquí, para completar el registro de tus predicciones.",
          icon: "info",
          confirmButtonText: "Ok",
          background: "rgba(0, 20, 79, 0.8)",
          confirmButtonColor: "#ff0000",
          color: "#fff",
        });

        setTimeout(() => {
          this.$router.push("/predicciones-pilotos-max");
        }, 1500);
      } else {
        this.$router.push("/predicciones-pilotos-max");
      }
    },
    obtenerCarrera(){
      axios
      // .get('https://www.mobilpredictor.com.mx/datos/api/carreraActual')
      // .get('http://127.0.0.1:8000/api/carrera')
      .get('https://api.mobilpredictor2025.vmtec.com.mx/api/carreraActual')
      .then((response) => {
        const raceData = response.data;
        // Para la vista
        this.name_race = JSON.stringify(raceData.carrera.name);
        this.circuito = JSON.stringify(raceData.carrera.circuit);
        this.ciudad = JSON.stringify(raceData.carrera.city);
        if (!this.gp || this.gp === "0") {
          const fallbackGp = raceData?.carrera?.id || raceData?.carrera?.gp || raceData?.gp;
          if (fallbackGp) {
            this.gp = String(fallbackGp);
            localStorage.setItem("gp", String(fallbackGp));
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
  },
  computed: {
    isFormComplete() {
      return this.form.every(item => {
        return item.respuesta1 !== "" && item.respuesta2 !== "";
      });
    },
  },
  watch: {
    isFormComplete(newVal) {
      console.log('isFormComplete:', newVal);
    }
  },
  mounted() {
    if (!localStorage.getItem('predictor')) {
      this.$router.push('/iniciar-sesion');
    }

    const cookieExists = document.cookie.includes("PrediccionesEnviadas");
    this.isFormVisible = cookieExists;
    this.getGP();
    this.obtenerCarrera();
    this.startPredictionTimerLabel();
  },
  beforeDestroy() {
    if (this.predictionTimerInterval) {
      clearInterval(this.predictionTimerInterval);
    }
  },
};
</script>
